import { createFileRoute } from "@tanstack/react-router";
import { useWebhookMutations } from "#app/hooks/settings/use-webhook-mutations";
import { WebhookFormView } from "#app/components/settings/webhook-form-view";
import type { CreateWebhookInput } from "#app/lib/data";
import { useAppNavigate } from "#app/lib/hooks/use-app-navigate";
import { withPermission } from "#app/components/permissions/require-permission";

function WebhookCreatePage() {
  const { replace } = useAppNavigate();
  const { createWebhook } = useWebhookMutations();

  const navigateBack = () => replace("/settings/api");

  // A saved webhook lands on its own detail page: the sentence and the
  // Enabled switch there confirm what was just set up, where the list would
  // only show one more row. A failed save stays put (the mutation toasts).
  async function handleSubmit(data: CreateWebhookInput) {
    const created = await createWebhook(data);
    if (created) replace(`/settings/api/webhooks/${created.webhookId}`);
  }

  return (
    <WebhookFormView
      webhook={null}
      onCancel={navigateBack}
      onSubmit={handleSubmit}
    />
  );
}

export const Route = createFileRoute("/(app)/$workspace/settings/api/webhooks/create")({
  component: withPermission("workspace.integrations", WebhookCreatePage),
});
